import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Category } from '@interfaces/dws/transactional-email';
import { WineryInfo } from '@interfaces/dws/winery-info';
import { WineryParametersService } from '@services/dws/winery-parameters.service';
import { toast } from '@web/util/toast';
import { tr } from '@util/tr';

@Component({
  selector: 'failed-payment',
  templateUrl: './failed-payment.component.html',
  styleUrls: ['./failed-payment.component.scss']
})
export class FailedPaymentComponent {
  text!: string;
  actionText: string | undefined;
  items?: string[];
  isWarning = true;
  isAction = false;
  callback?: () => void;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dlg: MatDialogRef<FailedPaymentComponent>,
    private wineryParametersService: WineryParametersService
  ) {
    this.text = data.text;
    this.actionText = data.actionText;
    this.items = data.items;
    this.isWarning = data.isWarning !== false;
    this.isAction = data.isAction !== false;
    this.callback = data.callback;
  }

  closeClicked() {
    this.dlg.close();
  }

  async saveClicked() {
    if (this.callback) {
      await this.callback.apply(this);
    }
    this.dlg.close();
  }
}